import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const AboutModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="Nanu ya ini?!" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        This clone of the game Wordle in Kapampangan. The game was forked from hannahcode's open source implementation{' '}
        <a
          href="https://github.com/hannahcode/wordle"
          className="underline font-bold"
        >
          here
        </a>{' '}
        and uses words from Forman's Kapampangan Words via{' '}
        <a
          href="https://github.com/kixpanganiban/amanu"
          className="underline font-bold"
        >
          github.com/kixpanganiban/amanu
        </a>
      </p>
    </BaseModal>
  )
}
